import { render, staticRenderFns } from "./products-services.vue?vue&type=template&id=00fdb488&scoped=true"
import script from "./products-services.vue?vue&type=script&lang=js"
export * from "./products-services.vue?vue&type=script&lang=js"
import style0 from "./products-services.vue?vue&type=style&index=0&id=00fdb488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fdb488",
  null
  
)

export default component.exports